import * as React from "react";
import {Card} from "react-bootstrap";

type CardSectionProps = {
    header: string | React.ReactNode;
    className?: string;
    headerClassName?: string;
    as?: React.ElementType;
    children: React.ReactNode;
    "data-testid"?: string;
};

export const CardSection = ({
                                header,
                                className,
                                headerClassName,
                                as,
                                children,
                                "data-testid": dataTestId,
                            }: CardSectionProps) => (
    <Card className={className} data-testid={dataTestId}>
        <Card.Header as={as ?? 'h5'} data-testid="card-header" className={headerClassName}>
            {typeof header === "string" ? <span>{header}</span> : header}
        </Card.Header>
        <Card.Body>{children}</Card.Body>
    </Card>
);